import View from 'cdna/core/view';
import markup from './videoLineView.html';

export default View.extend({
    el: markup,
    name: function() {
        return 'video-' + this.model.get('Id')
    },         
    bindings: {
        'Id': 'attr video-id',
        'Name [data-bind=name]': 'text',
        'durationDescription [data-bind=duration]': 'text',
    }
});


/** WEBPACK FOOTER **
 ** ./client/video/videoLineView.js
 **/